// extracted by mini-css-extract-plugin
module.exports = {"cta":"Cta-module--cta--18HyJ"};